import { Snackbar, Alert } from '@mui/material'
import React from 'react'

interface ICopySuccessSnackbarProps {
  open: boolean
  onClose: () => void
  message?: string
}

const CopySuccessSnackbar: React.FC<ICopySuccessSnackbarProps> = ({
  open,
  onClose,
  message = 'Copied to clipboard!',
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={2500}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert
        onClose={onClose}
        severity="success"
        sx={{
          width: '100%',
          backgroundColor: '#43a047',
          color: '#fff',
          '& .MuiAlert-icon': {
            color: '#fff',
          },
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  )
}

export default CopySuccessSnackbar
